var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hero/Outline/layers"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5486 2.10712C11.833 1.96494 12.1677 1.96495 12.452 2.10712L20.4297 6.09594C21.1742 6.46819 21.174 7.53052 20.4297 7.90268L12.452 11.8915C12.1677 12.0337 11.833 12.0337 11.5486 11.8915L3.57101 7.90268C2.8265 7.53043 2.82668 6.4681 3.57101 6.09594L11.5486 2.10712ZM12.0003 4.11734L6.2364 6.99931L12.0003 9.88127L17.7643 6.99931L12.0003 4.11734Z",
    fill: "#2C3236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10579 11.5521C3.35278 11.0581 3.95345 10.8579 4.44743 11.1049L12.0002 14.8813L19.553 11.1049C20.047 10.8579 20.6477 11.0581 20.8946 11.5521C21.1416 12.0461 20.9414 12.6467 20.4474 12.8937L12.4519 16.8915C12.1675 17.0337 11.8329 17.0337 11.5485 16.8915L3.55301 12.8937C3.05903 12.6467 2.8588 12.0461 3.10579 11.5521Z",
    fill: "#2C3236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.44743 16.1049C3.95345 15.8579 3.35278 16.0581 3.10579 16.5521C2.8588 17.0461 3.05903 17.6467 3.55301 17.8937L11.5485 21.8915C11.8329 22.0337 12.1675 22.0337 12.4519 21.8915L20.4474 17.8937C20.9414 17.6467 21.1416 17.0461 20.8946 16.5521C20.6477 16.0581 20.047 15.8579 19.553 16.1049L12.0002 19.8813L4.44743 16.1049Z",
    fill: "#2C3236"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayersIcon);
export default __webpack_public_path__ + "static/media/layers-icon.4ca384a40b9715ccd6f41e2162e86dd7.svg";
export { ForwardRef as ReactComponent };